import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "../components_root/rendom_code";

export const Save_note_message = async (data) => {
  const { note_message, pbuid } = data || {};

  // 1. Validate inputs
  if (!note_message?.trim()) {
    return { success: false, error: "Missing  message" };
  }

  if (!pbuid?.trim()) {
    return { success: false, error: "Missing  contact" };
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");

  if (!sessiontoken || sessiontoken === "undefined") {
    return { success: false, error: "Session expired. Please relogin." };
  }

  if (!guid || guid === "undefined") {
    return { success: false, error: "Login expired. Please relogin." };
  }

  try {
    const tablename = "phonebook_note_remader";

    // ✅ Check already exists for this user
    const phonebookQuery = query(
      collection(db, "phonebook"),
      where("uid", "==", pbuid),
      where("guid", "==", guid)
    );

    const snap = await getDocs(phonebookQuery);

    if (snap.empty) {
      return { success: false, error: "Missing Contact number" };
    }
    // ✅ Save parent document
    const uid = Randomcode(15);
    const parentDocRef = doc(db, tablename, uid);
    const savequery = {
      ...data,
      uid,
      status: true,
      star: false,
      guid,
      sessiontoken,
      date_time: new Date(),
    };
    await setDoc(parentDocRef, savequery);
    return { success: true };

  } catch (err) {
    console.error("❌ Error saving document:", err);
    return { success: false, error: err.message || "Unknown error" };
  }
};
